<template lang="pug">
    .sites.is-clearfix
        Site(
            v-for="( site, i ) in sites"
            :key="site.id"
            :index="i"
            :site="site"
        )
</template>

<script>

import _ from 'lodash'

import Site from './Site'

export default {
    name: 'Sites',
    props: {
        section: {
            type: Object,
            required: true,
        },
    },
    components: {
        Site,
    },
    computed: {
        sites() {
            let sites = this.section.contents || []
            return _.cloneDeep(sites).sort((a, b) => _.get(a, 'position', 0) - _.get(b, 'position', 0))
        },
    }
}
</script>
 

<style lang="sass" scoped>
@import "~bulma/sass/utilities/mixins"
.sites
    display: flex
    flex-direction: row
    flex-wrap: wrap
    @media screen and (max-width: 580px)
        display: flex
        flex-direction: column
</style>
